<template>
  <v-card>
    <v-toolbar flat color="primary">
      <v-toolbar-title class="body-2">
        <span class="headline">Remote Consent</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="card-container">
      <span class="subheading">Processed vid Remote Consent</span>
      <v-container fluid>
        <v-radio-group v-model="selectResult" row>
          <v-radio label="Yes" value="1"></v-radio>
          <v-radio label="No" value="0"></v-radio>
        </v-radio-group>
      </v-container>
    </v-card-text>
    <v-card-actions style="margin-top: -20px">
      <v-spacer></v-spacer>
      <v-btn text @click="saveRemoteConsent">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { OriginationApi } from '@/api/pandaria'
import { Popup, Tool } from '@/util/index'
const popup = new Popup()
const tool = new Tool()
export default {
  name: 'remote-consent-dialog',
  props: {
    loanId: Number
  },
  data () {
    return {
      selectResult: null
    }
  },
  methods: {
    hideDialog () {
      this.checkbox = {
        yesCheckbox: false,
        noCheckbox: false
      }
      this.$emit('hideDialog', 'REMOTE_CONSENT')
    },
    saveRemoteConsent () {
      const $this = this
      if (tool.isEmpty(this.selectResult)) {
        popup.popupForWarning('Please select a checkbox')
        return
      }
      const saveData = {
        loanId: this.loanId,
        feature: 'REMOTE_CONSENT',
        featureData: {
          flags: this.selectResult
        }
      }
      OriginationApi.addSectionFeature(saveData, function (result) {
        $this.hideDialog()
        popup.popupForSuccess('Success')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  margin-top: 10px !important;
  .subheading {
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
